import './ErrorBox.css';

const ErrorBox = ({ error }: { error: unknown }) => {
    return <div className="ErrorBox">{`${error}`}</div>;
};

export default ErrorBox;
